
export const container = {
  display: 'flex',
  minHeight: '100vh',
  position: 'relative',
  fontFamily: "'Montserrat', sans-serif",
}

export const leftPanel = {
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  // backgroundColor: '#fff',
  padding: '2rem',
  minHeight: '100vh',
}

export const infoStyle = {
  color: "#0085C1",
  fontSize: "14px",
  marginBottom: "12px",
  textAlign: "center"
}


export const rightPanel = {
  flex: '1 1 0%',
  backgroundColor: '#0085C1',
  clipPath: 'polygon(100% 0%, 100% 49%, 100% 100%, 25% 100%, 36% 53%, 25% 0%)',
  position: 'relative',
  overflow: 'hidden',
}


export const imageBox = {
  position: 'absolute',
  top: '50%',
  right: '10%',
  transform: 'translate(0, -50%)',
  zIndex: 1,
  pointerEvents: 'none',
  width: '600px',
  height: '600px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

  // width: '600px',
  // height: '600px',
  // position: 'absolute',
  // top: '50%',
  // left: '65%',
  // transform: 'translate(-50%, -50%)',
  // zIndex: 2,
  // pointerEvents: 'none',
}

export const containerMobile = {
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100vh',
  fontFamily: "'Montserrat', sans-serif",
  // backgroundColor: '#fff',
}

export const leftPanelMobile = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  // backgroundColor: '#fff',
  padding: '1rem',
  width: '100%',
}

export const imageBoxMobile = {
  position: 'static',
  width: '100%',
  height: '200px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '1rem',
}

export const containerTablet = {
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100vh',
  fontFamily: "'Montserrat', sans-serif",
  // backgroundColor: '#fff',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '2rem 1rem',
  gap: '2rem',
}

export const leftPanelTablet = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  // backgroundColor: '#fff',
  width: '100%',
  maxWidth: '500px',
}

export const imageBoxTablet = {
  position: 'static',
  width: '100%',
  maxWidth: '600px',
  height: 'auto',
  aspectRatio: '1516/1267',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '1rem',
}

export const containerForm = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  flex: '1 1 0%',
  zIndex: 1,
  // backgroundColor: 'rgb(255, 255, 255)',
  position: 'relative',
  width: '100%',
  textAlign: 'center',
  padding: '1rem',
}

export const filhaForm = {
  textAlign: 'center',
  width: '100%',
  maxWidth: '400px',
}

export const formBox = {
  width: '100%',
  maxWidth: '400px',
  textAlign: 'center',
}

export const titleStyle = {
  fontSize: '2rem',
  fontWeight: '700',
  marginBottom: '0.5rem',
  margin: '0 0 16px',
  fontFamily: "'Montserrat', sans-serif",
  color: '#111827',
}

export const subtitleStyle = {
  color: '#6B7280',
  marginBottom: '2rem',
  fontSize: '16px',
  fontWeight: '400',
  fontFamily: "'Montserrat', sans-serif",
  lineHeight: '1.5',
}

export const otpContainer = {
  display: 'flex',
  justifyContent: 'center',
  gap: '0.75rem',
  marginBottom: '2rem',
  flexWrap: 'nowrap',
  width: '100%',
  maxWidth: '380px',
  margin: '0 auto 2rem auto',
}

export const otpInputStyle = {
  width: '48px',
  height: '48px',
  borderRadius: '12px',
  border: '1px solid #E5E7EB',
  fontSize: '1.25rem',
  fontWeight: '500',
  textAlign: 'center',
  outline: 'none',
  fontFamily: "'Montserrat', sans-serif",
  transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
  boxSizing: 'border-box',
  flexShrink: 0,
}

export const verifyButtonStyle = {
  width: "100%",
  backgroundColor: "#0085C1",
  color: "#fff",
  padding: '1rem',
  border: "none",
  borderRadius: '2rem',
  fontWeight: 'bold',
  fontSize: '1rem',
  marginBottom: '1.5rem',
  cursor: "pointer",
  fontFamily: "'Montserrat', sans-serif",
  height: '48px',
  transition: 'all 0.2s ease',
}

export const resendContainer = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  color: '#6B7280',
  fontSize: '0.875rem',
  fontFamily: "'Montserrat', sans-serif",
}

export const resendButtonStyle = {
  background: 'none',
  border: 'none',
  fontWeight: 'bold',
  cursor: 'pointer',
  textDecoration: 'underline',
  color: '#2563EB',
  fontSize: '0.875rem',
  fontFamily: "'Montserrat', sans-serif",
  transition: 'color 0.2s ease',
}

export const timerStyle = {
  color: '#6B7280',
  fontSize: '0.875rem',
  fontFamily: "'Montserrat', sans-serif",
}

export const errorStyle = {
  color: "#DC2626",
  marginBottom: "1rem",
  fontFamily: "'Poppins', sans-serif",
  fontSize: "0.875rem",
  padding: "0.75rem",
  backgroundColor: "#FEF2F2",
  border: "1px solid #FECACA",
  borderRadius: "0.5rem",
}

export const voltarLogin = {
  display: 'flex',
  justifyContent: 'flex-start',
  padding: '1rem',
}

export const botaoVoltar = {
  backgroundColor: 'transparent',
  color: '#6B7280',
  fontWeight: '400',
  fontFamily: "'Montserrat', sans-serif",
  padding: '0.5rem 1rem',
  fontSize: '1rem',
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
  cursor: 'pointer',
  transition: 'opacity 0.2s ease'
}

export const boxWrap = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  minHeight: "100vh",
  background: "#f5f7fb",
  padding: 16,
};

export const card = {
  width: 520,
  maxWidth: "100%",
  background: "#ffffff",
  borderRadius: 16,
  boxShadow: "0 8px 32px rgba(0, 0, 0, 0.08)",
  padding: 32,
};

export const headerRow = {
  display: "flex",
  alignItems: "center",
  gap: 12,
  marginBottom: 8,
};

export const checkIcon = {
  width: 32,
  height: 32,
  // borderRadius: "50%",
  // background: "#12B76A",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
};

export const title = {
  fontSize: 18,
  fontWeight: 600,
  color: "#101828",
  margin: 0,
  lineHeight: "24px",
};

export const text = {
  fontSize: 14,
  lineHeight: "20px",
  color: "#667085",
  marginTop: 8,
  marginBottom: 24,
};

export const actions = {
  display: "flex",
  gap: 12,
  marginTop: 8,
};

export const primary = {
  padding: "10px 16px",
  borderRadius: 8,
  background: "#0055ff",
  color: "#fff",
  fontWeight: 600,
  cursor: "pointer",
};

export const ghost = {
  padding: "10px 16px",
  borderRadius: 10,
  border: "1px solid #EAECF0",
  background: "#fff",
  color: "#344054",
  fontWeight: 600,
  cursor: "pointer",
};